import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { InboxDetailsQuery, InboxDetailsQueryVariables } from '@/shared/api';
import INBOX_DETAILS_QUERY from '../queries/inboxDetails';

/**
 * Loads the full report behind an inbox entry. Runs the inbox details query for the id and throws the first GraphQL error only when no report came back.
 *
 * @param id - Identifier of the inbox report.
 * @returns A promise resolving to the inbox report detail.
 */
const fetcInboxDetails = async (id: any) => {
  const client = createClient();
  const inboxDetailsResult = await client.query<InboxDetailsQuery, InboxDetailsQueryVariables>({
    query: INBOX_DETAILS_QUERY,
    variables: {
      id,
    },
  });
  const { data, errors } = inboxDetailsResult;
  const { report } = data;
  if (_.isNil(report) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return report;
};

export default fetcInboxDetails;
